export const PERMS = {
    READ: 'tracing.read',
}
